import { ActionTree } from 'vuex'
import axios, { CancelTokenStatic } from 'axios'
import _get from 'lodash/get'
import _find from 'lodash/find'

import { BASE_URL } from '@/config'
import { OffersState } from './types'
import { RootState } from '../types'
import { Seller, Offer, OfferItem } from '@/types'

// const cancelToken: CancelTokenStatic = axios.CancelToken;
// let cancelSource = cancelToken.source();
// export const refreshToken = (() => {
//   cancelSource = cancelToken.source();
// });
// export const cancelAllRequests = (() => {
//   cancelSource.cancel();
// });

export const actions: ActionTree<OffersState, RootState> = {
  getOffers({ commit }, payload) {
    const path = `${BASE_URL}/offers`
    const params = {
      ...payload,
    }

    commit('setRequestGetOffers', true)

    return axios
      .get(path, { params })
      .then(response => {
        const data = _get(response, 'data') || []
        return data
      })
      .catch(err => {
        throw err
      })
      .finally(() => {
        commit('setRequestGetOffers', false)
      })
  },
  getOffer({ commit }, payload) {
    const path = `${BASE_URL}/offer`
    const params = {
      ...payload,
    }

    commit('setRequestGetOffer', true)

    return axios
      .get(path, { params })
      .then(response => {
        const data = _get(response, 'data') || null
        commit('setOffer', { offer: data })
        return data
      })
      .catch(err => {
        commit('setOffer', { offer: null })
        throw err
      })
  },
  getOfferItems({ commit }, payload) {
    const path = `${BASE_URL}/offer-items`
    const params = {
      offerId: payload.offerId,
      limit: payload.limit,
      offset: payload.offset || 0,
      order: payload.order || [],
      filter: payload.filter || {},
      keyword: payload.keyword || '',
    }

    return axios
      .get(path, { params })
      .then(response => {
        return _get(response, 'data' || [])
      })
      .catch(err => {
        throw err
      })
  },
  postOfferProcess({ commit }, payload: { id; token; offerProcessType }): any {
    const path = `${BASE_URL}/offer/${payload.offerProcessType}`
    commit('setRequestPostProcess', true)
    return axios
      .get(path, {
        params: {
          id: payload.id,
          token: payload.token,
        },
      })
      .then(response => {
        const data = _get(response, 'data') || null
        commit('offerProcessed', data)
        return data
      })
      .catch(err => {
        throw err
      })
      .finally(() => {
        commit('setRequestPostProcess', false)
      })
  },
  getSellers({ commit }, payload) {
    const path = `${BASE_URL}/sellers`
    const params = {
      buyerUserId: payload.buyerUserId,
      limit: payload.limit,
      offset: payload.offset || 0,
      order: payload.order || [],
      filter: payload.filter || {},
      keyword: payload.keyword || '',
    }

    return axios
      .get(path, { params })
      .then(response => {
        const data = _get(response, 'data') || []
        return data
      })
      .catch(err => {
        throw err
      })
  },
  getBuyers({ commit }, payload) {
    const path = `${BASE_URL}/buyers`
    const params = {
      userId: payload.userId,
      limit: payload.limit,
      offset: payload.offset || 0,
      order: payload.order || [],
      filter: payload.filter || {},
      keyword: payload.keyword || '',
    }

    return axios
      .get(path, { params })
      .then(response => {
        const data = _get(response, 'data') || []
        return data
      })
      .catch(err => {
        throw err
      })
  },
}
